import { Step, StepId } from 'interfaces'

export const steps: Step[] = [
  { id: StepId.ORDER, navTitle: 'Order' },
  { id: StepId.DOTS, navTitle: '...' },
  { id: StepId.SUBMIT, navTitle: 'Submit' }
]
